import React from 'react';
import { Dropdown } from '../dropdown/Dropdown';

export interface SplitACChecklistRow {
    srNo: number;
    particulars: string;
    status: string | null;
    remarks: string | null;
}

interface SplitACChecklistTableProps {
    data: SplitACChecklistRow[];
    onChange: (index: number, updatedRow: SplitACChecklistRow) => void;
    isViewMode?: boolean;
}

const statusOptions = [
    { value: 'Complied', label: 'Complied' },
    { value: 'Not Complied', label: 'Not Complied' },
    { value: 'Partially Complied', label: 'Partially Complied' },
    { value: 'Not Applicable', label: 'Not Applicable' },
];

const SplitACChecklistTable: React.FC<SplitACChecklistTableProps> = ({
    data,
    onChange,
    isViewMode = false,
}) => {
    return (
        <div className="bg-white rounded-lg shadow mt-6 overflow-hidden">
            <div className="p-4 border-b">
                <h2 className="text-xl font-bold">Split AC – Inspection & Maintenance Checklist</h2>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left">
                    <thead className="bg-[#1C2C54] text-white">
                        <tr>
                            <th className="px-4 py-3 font-semibold w-16">Sr. No.</th>
                            <th className="px-4 py-3 font-semibold">Inspection Checklist of Split AC</th>
                            <th className="px-4 py-3 font-semibold w-48">Status</th>
                            <th className="px-4 py-3 font-semibold w-64">Remarks</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {data.map((row, index) => (
                            <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                <td className="px-4 py-3 align-top">{row.srNo}</td>
                                <td className="px-4 py-3 align-top whitespace-pre-wrap">{row.particulars}</td>
                                <td className="px-4 py-3 align-top">
                                    <select
                                        value={row.status || ''}
                                        onChange={(e) => onChange(index, { ...row, status: e.target.value })}
                                        disabled={isViewMode}
                                        className="w-full p-2 border rounded border-gray-300 focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                                    >
                                        <option value="" disabled>Select Status</option>
                                        {statusOptions.map(opt => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                </td>
                                <td className="px-4 py-3 align-top">
                                    <input
                                        type="text"
                                        value={row.remarks || ''}
                                        onChange={(e) => onChange(index, { ...row, remarks: e.target.value })}
                                        disabled={isViewMode}
                                        placeholder={(row.status === 'Partially Complied' || row.status === 'Not Complied') ? 'Mandatory Remarks' : 'Optional Remarks'}
                                        required={row.status === 'Partially Complied' || row.status === 'Not Complied'}
                                        className={`w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 ` +
                                            ((row.status === 'Partially Complied' || row.status === 'Not Complied') && (!row.remarks || row.remarks.trim() === '') ? 'border-red-500' : 'border-gray-300')
                                        }
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SplitACChecklistTable;
